/*
* js数组实现权重概率分配，支持数字比模式（两位小数以上）和百分比模式（不支持小数）
* @params  Array  arr  js数组，参数类型[Object, Object]
* */
const weightRand = (arr: any) => {
  //参数arr元素必须含有weight属性，参考如下所示
  //求出最大公约数以计算缩小倍数，perMode为百分比模式
  let per;
  let maxNum = 0;
  let perMode = false;

  // 自定义Math求最小公约数方法
  const gcd: any = (a: any, b: any) => {
    const min = Math.min(a,b);
    const max = Math.max(a,b);
    let result = 1;
    if (a === 0 || b === 0) {
      return max;
    }
    for(let i = min; i >= 1; i--) {
      if (min % i === 0 && max % i === 0) {
        result = i;
        break;
      }
    }
    return result;
  }

  //使用clone元素对象拷贝仍然会造成浪费，但是使用权重数组对应关系更省内存
  const weight_arr = [];
  for (let i = 0; i < arr.length; i++) {
    if ('undefined' !== typeof(arr[i].weight)) {
      if (arr[i].weight.toString().indexOf('%') !== -1) {
        per = Math.floor(arr[i].weight.toString().replace('%', ''));
        perMode = true;
      } else {
        per = Math.floor(arr[i].weight * 100);
      }
    } else {
      per = 0;
    }
    weight_arr[i] = per;
    maxNum = gcd(maxNum, per);
  }

  const index = [];
  let total = 0;
  let len = 0;
  if(perMode) {
    for (let i = 0; i < arr.length; i++) {
      //len表示存储arr下标的数据块长度，已优化至最小整数形式减小索引数组的长度
      len = weight_arr[i];
      for (let j = 0; j < len; j++) {
        //超过100%跳出，后面的舍弃
        if(total >= 100) {
          break;
        }
        index.push(i);
        total++;
      }
    }
    //使用最后一个元素补齐100%
    while(total < 100) {
      index.push(arr.length-1);
      total++;
    }
  } else {
    for (let i = 0; i < arr.length; i++) {
      //len表示存储arr下标的数据块长度，已优化至最小整数形式减小索引数组的长度
      len = weight_arr[i]/maxNum;
      for (let j = 0; j < len; j++) {
        index.push(i);
      }
      total += len;
    }
  }
  //随机数值，其值为0-11的整数，数据块根据权重分块
  const rand = Math.floor(Math.random() * total);
  return arr[index[rand]];
}

export default weightRand;